import React from 'react'

import { Box, Body2, Link, LinkVariant, TextAlign } from '@gousto-internal/citrus-react'

import config from 'config/routes'
import { useIsFiveForFourEnabled } from 'hooks/useIsFiveForFourEnabled'
import { useGetHomePageExperiments } from 'routes/Home/homeHooks'

interface Props {
  children: React.ReactNode
}

export const FooterNotice = ({ children }: Props) => {
  const isFiveForFourFeatureEnabled = useIsFiveForFourEnabled()
  const { isHomepageRedesignEnabled } = useGetHomePageExperiments()

  return (
    <Box
      paddingH={[3, 8, 8, 8]}
      paddingV={0}
      paddingBottom={4}
      maxWidth={['100%', '60rem', '60rem', '60rem']}
      style={{ margin: 'auto' }}
    >
      <Body2>
        {isFiveForFourFeatureEnabled
          ? '£2.99 per meal is based on a standard 5 recipe box for 4 people with a subscription, excluding £3.99 delivery'
          : children}
      </Body2>
      {isHomepageRedesignEnabled && (
        <Body2 textAlign={TextAlign.Center}>
          † To verify our carbon footprint claims, click&nbsp;
          <Link href={config.client.carbonFootprintComparison} variant={LinkVariant.None}>
            here
          </Link>
        </Body2>
      )}
    </Box>
  )
}
